export interface TlearningCategory {
    id?: number,
    name: string,
    slug: string,
    description: string,
    thumbnail: string,
    active: boolean
}
export const initialLearningCategory: TlearningCategory = {
    name: "",
    slug: "",
    description: "",
    thumbnail: "",
    active: false
}